/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { createReducer, on } from '@ngrx/store';
import * as RootStoreActions from './root-store.actions';
import { initialState, IRootStoreState } from './root-store.state';

export const rootStoreReducer = createReducer(
    initialState,
    on(
        RootStoreActions.setLoading,
        (state: IRootStoreState, { loading }): IRootStoreState => ({
            ...state,
            loading,
        }),
    ),
);
